var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#ECF9EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5938 10.375H9.40625C8.62928 10.375 8 11.0082 8 11.7812V20.2188C8 20.9964 8.63391 21.625 9.40625 21.625H22.5938C23.3642 21.625 24 20.9991 24 20.2188V11.7812C24 11.0096 23.3732 10.375 22.5938 10.375ZM22.3968 11.3125C22.1095 11.5983 17.1651 16.5167 16.9944 16.6865C16.7288 16.9521 16.3756 17.0983 16 17.0983C15.6244 17.0983 15.2712 16.9521 15.0047 16.6856C14.8899 16.5714 10.0001 11.7073 9.60319 11.3125H22.3968ZM8.9375 20.0279V11.9727L12.9887 16.0025L8.9375 20.0279ZM9.60378 20.6875L13.6534 16.6637L14.3427 17.3494C14.7854 17.7921 15.374 18.0358 16 18.0358C16.626 18.0358 17.2146 17.7921 17.6564 17.3503L18.3466 16.6637L22.3962 20.6875H9.60378ZM23.0625 20.0279L19.0113 16.0025L23.0625 11.9727V20.0279Z",
    fill: "#46C35F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/Envelope.168603ee1c16cc6052a651ec8b7dccd9.svg";
export { ForwardRef as ReactComponent };